import React from 'react';
import TripPreviewTab from "./trip/TripPreviewTab";
import TripProgrammTab from "./trip/TripProgrammTab";
import TripHotelTab from "./trip/TripHotelTab";
import TripReferencesTab from "./trip/TripReferencesTab";
import TripSeeingsTab from "./trip/TripSeeingsTab";
import TripInfoTab from "./trip/TripInfoTab";
import TripDatesTab from "./trip/TripDatesTab";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import TripServicesTab from "./trip/TripServicesTab";
import {Accordion, Tab, Tabs} from "react-bootstrap";
import {BrowserView, MobileView} from "react-device-detect";

const TripLeft = ({
                      activeKey,
                      setActiveKey,
                      tripId,
                      trip,
                      seeings,
                      references,
                      appointments,
                      isAppointmentsLoading,
                      accommodations,
                      includedServices,
                      excludedServices,
                      localServices,
                      notIncludedServices
                  }) => {


    const placeholderImages = [{
        thumbnail: process.env.PUBLIC_URL + '/images/img-placeholder.webp',
        original: process.env.PUBLIC_URL + '/images/img-placeholder.webp',
    }];
    const images = [];
    trip.images?.map((img) => (
        images.push({
            description: `${img.Beschreibung}`,
            thumbnail: `${process.env.REACT_APP_IMG_PATH}/${img.Bildname}_low.jpg`,
            original: `${process.env.REACT_APP_IMG_PATH}/${img.Bildname}.jpg`,
        })
    ))

    return (
        <div className="images images_single_left col-xl-8 col-md-6 col-sm-12 order-md-1 ">
            <div className="title-single">
                <div className="title">
                    <h1>{trip.Kurztitel}</h1>
                </div>
            </div>

            <div className="flexslider">
                <ImageGallery lazyLoad={true} thumbnailPosition="bottom"
                              items={images.length === 0 ? placeholderImages : images}/>
            </div>

            <div className="clear"></div>

            <BrowserView>
                <Tabs
                    defaultActiveKey="tab-tripPreviewTab"
                    id="trip-tabs"
                    className="trip mb-3 m-0"
                    fill
                    activeKey={activeKey}
                    onSelect={(k) => setActiveKey(k)}
                >
                    <Tab eventKey="tab-tripPreviewTab" title="Überblick">
                        <TripPreviewTab trip={trip}></TripPreviewTab>
                    </Tab>
                    <Tab eventKey="tab-tripProgrammTab" title="Reiseprogramm">
                        <TripProgrammTab trip={trip}></TripProgrammTab>
                    </Tab>
                    <Tab eventKey="tab-tripHotelTab" title="So wohnen Sie">
                        <TripHotelTab trip={trip}></TripHotelTab>
                    </Tab>
                    <Tab eventKey="tab-tripServicesTab" title="Leistungen">
                        <TripServicesTab
                            trip={trip}
                            includedServices={includedServices}
                            excludedServices={excludedServices}
                            localServices={localServices}
                            notIncludedServices={notIncludedServices}></TripServicesTab>
                    </Tab>
                    {seeings.length > 0 &&
                        <Tab eventKey="tab-tripSeeingsTab" title="Sehenswertes">
                            <TripSeeingsTab trip={trip} seeings={seeings}></TripSeeingsTab>
                        </Tab>
                    }
                    <Tab eventKey="tab-tripInfoTab" title="Wichtige Infos">
                        <TripInfoTab trip={trip}></TripInfoTab>
                    </Tab>
                    <Tab eventKey="tab-tripReferencesTab" title="Bewertungen">
                        <TripReferencesTab trip={trip} references={references}></TripReferencesTab>
                    </Tab>

                    <Tab eventKey="tab-tripDatesTab" title="Termine und Preise" id="tab-tripDatesTab">
                        <TripDatesTab
                            trip={trip}
                            appointments={appointments}
                            loading={isAppointmentsLoading}
                            accommodations={accommodations}></TripDatesTab>
                    </Tab>
                </Tabs>
            </BrowserView>

            <MobileView>
                <Accordion
                    className="trip"
                    defaultActiveKey="tab-tripPreviewTab"
                    activeKey={activeKey}
                    onSelect={(k) => setActiveKey(k)}
                >
                    <Accordion.Item eventKey="tab-tripPreviewTab">
                        <Accordion.Header>Überblick</Accordion.Header>
                        <Accordion.Body>
                            <TripPreviewTab trip={trip}></TripPreviewTab>
                        </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="tab-tripProgrammTab">
                        <Accordion.Header>Reiseprogramm</Accordion.Header>
                        <Accordion.Body>
                            <TripProgrammTab trip={trip}></TripProgrammTab>
                        </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="tab-tripHotelTab">
                        <Accordion.Header>So wohnen Sie</Accordion.Header>
                        <Accordion.Body>
                            <TripProgrammTab trip={trip}></TripProgrammTab>
                        </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="tab-tripServicesTab">
                        <Accordion.Header>Leistungen</Accordion.Header>
                        <Accordion.Body>
                            <TripServicesTab
                                trip={trip}
                                includedServices={includedServices}
                                excludedServices={excludedServices}
                                localServices={localServices}
                                notIncludedServices={notIncludedServices}></TripServicesTab>
                        </Accordion.Body>
                    </Accordion.Item>

                    {seeings.length > 0 &&
                        <Accordion.Item eventKey="tab-tripSeeingsTab">
                            <Accordion.Header>Sehenswertes</Accordion.Header>
                            <Accordion.Body>
                                <TripProgrammTab trip={trip}></TripProgrammTab>
                            </Accordion.Body>
                        </Accordion.Item>
                    }

                    <Accordion.Item eventKey="tab-tripInfoTab">
                        <Accordion.Header>Wichtige Infos</Accordion.Header>
                        <Accordion.Body>
                            <TripInfoTab trip={trip}></TripInfoTab>
                        </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="tab-tripReferencesTab">
                        <Accordion.Header>Bewertungen</Accordion.Header>
                        <Accordion.Body>
                            <TripReferencesTab trip={trip} references={references}></TripReferencesTab>
                        </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="tab-tripDatesTab" id="tab-tripDatesTab">
                        <Accordion.Header>Termine und Preise</Accordion.Header>
                        <Accordion.Body>
                            <TripDatesTab
                                trip={trip}
                                appointments={appointments}
                                loading={isAppointmentsLoading}
                                accommodations={accommodations}></TripDatesTab>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            </MobileView>
        </div>
    )
}

export default TripLeft;